<template>
	<div class="page-content-wrapper">
		<div class="container-fluid">
			<div class="row">
				<evaluacionAlumno />
				<infoEvaluacionAlumno />
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex"
import evaluacionAlumno from "@/components/evaluacion/evaluacion-alumno/evaluacionAlumno"
import infoEvaluacionAlumno from '@/components/evaluacion/evaluacion-alumno/infoEvaluacionAlumno'

export default {
	components: {
		evaluacionAlumno,
		infoEvaluacionAlumno
	},
	data() {
		return {

		};
	},
	methods: {
		...mapActions("menu", ["updateMenu"]),
		...mapActions("menu", ["updateTitulo"]),
		
	},
	created() {

		let titulo = "Panel evaluación alumno";
		
		let menu = [
			{ urlTolbar: "index", nameToolbar: "Inicio" },
			{
				titulo: "Evaluacion - Curso",
				urlTolbar: "evaluacion-curso",
				nameToolbar: "Evaluacion Curso",
			},
			{
				titulo: "Evaluacion - Alumno",
				urlTolbar:
					"evaluacion-alumno/" + this.idAlumno + "/" + this.idEvaluacion,
				nameToolbar: "Evaluacion Biblioteca",
			},
		];
		this.updateMenu(menu);
		this.updateTitulo(titulo);
	},
};
</script>
